// extracted by mini-css-extract-plugin
export var btnWrapper = "styles-module--btn-wrapper--2c0bc";
export var description = "styles-module--description--7b579";
export var iconWrapper = "styles-module--icon-wrapper--eecc7";
export var mainContent = "styles-module--main-content--053c8";
export var title = "styles-module--title--216eb";